var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-tooltip" }, [
    _c("div", { staticClass: "tooltip__position-anchor" }, [
      _c("button", {
        ref: "anchor",
        staticClass: "tooltip__button",
        class: _vm.isOpenClass,
        on: { click: _vm.openTooltip },
      }),
      _vm._v(" "),
      _vm.showTooltip
        ? _c(
            "div",
            { staticClass: "tooltip", style: _vm.tooltipPosition },
            [
              _c("global-button", {
                staticClass: "tooltip__button--close",
                attrs: { icon: "close", theme: "secondary" },
                on: {
                  click: function ($event) {
                    _vm.showTooltip = false
                  },
                },
              }),
              _vm._v(" "),
              _vm.htmlContent !== "" && _vm.htmlContent
                ? [
                    _c("div", {
                      staticClass: "tooltip__content",
                      domProps: { innerHTML: _vm._s(_vm.htmlContent) },
                    }),
                    _vm._v(" "),
                    _vm._t("default"),
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "tooltip__content" },
                      [_vm._t("content"), _vm._v(" "), _vm._t("default")],
                      2
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }